import React, { useEffect, useContext, useState, useCallback, useRef } from 'react';
import ProjectOverviewHeader from './ProjectOverviewHeader';
import ProjectInfoCards from './ProjectInfoCards';
import '../../../../assets/scss/projectsOverview.scss';
import EventsTable from './EventsTable';
import Cards from './Cards';
import CollapsebaleComponent from './ClientPaymentCard';
import Context from '../../../../context/context';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { ReactComponent as DoubleArrowIcon } from '../../../../assets/svg/up-arrow.svg';
import { ReactComponent as ArrowIcon } from '../../../../assets/svg/deliverables/single_up_arrow.svg';
import { ReactComponent as EqualIcon } from '../../../../assets/svg/deliverables/equalto.svg';
import { ReactComponent as DownIcon } from '../../../../assets/svg/deliverables/single_down_arrow.svg';
import { ReactComponent as ActiveCamera } from '../../../../assets/svg/ProjectOverview/active-camera.svg';
import { ReactComponent as FadeCamera } from '../../../../assets/svg/ProjectOverview/fade-camera.svg';
import { ReactComponent as ActiveDrone } from '../../../../assets/svg/ProjectOverview/active-drone.svg';
import { ReactComponent as FadeDrone } from '../../../../assets/svg/ProjectOverview/fade-drone.svg';
import { ReactComponent as ActiveVideo } from '../../../../assets/svg/ProjectOverview/active-video.svg';
import { ReactComponent as FadeVideo } from '../../../../assets/svg/ProjectOverview/fade-video.svg';
import { ReactComponent as ActiveFilters } from '../../../../assets/svg/ProjectOverview/active-filters.svg';
import { ReactComponent as FadeFilters } from '../../../../assets/svg/ProjectOverview/fade-filters.svg';
import { ReactComponent as FadeRedFlag } from '../../../../assets/svg/ProjectOverview/fade-red-flag.svg';
import { ReactComponent as ActiveRedFlag } from '../../../../assets/svg/ProjectOverview/active-red-flag.svg';
import { ReactComponent as FadeYellowFlag } from '../../../../assets/svg/ProjectOverview/fade-yellow-flag.svg';
import { ReactComponent as ActiveYellowFlag } from '../../../../assets/svg/ProjectOverview/active-video.svg';
import { ReactComponent as FadeGreenFlag } from '../../../../assets/svg/ProjectOverview/fade-green-flag.svg';
import { ReactComponent as ActiveGreenFlag } from '../../../../assets/svg/ProjectOverview/active-green-flag.svg';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import LoadingBar from '../../../components/global/loadingBar';
import _ from 'lodash';

const ProjectsOverviewPage = () => {
	const urlParams = useParams();
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const params = Object.fromEntries(searchParams);
	const [load, setLoad] = useState(true);

	let {
		ProjectOverviewInfo: {
			projectVendorDetails,
			projectEventDetails,
			getALlProjectDetails,
			getAllVendorsEventDetails,
		},
		deliverableInfo: { getAllWorkspaceTenants, workspaceTenants },
	} = useContext(Context);

	const [pageInfo, setPageInfo] = useState({
		projectTitlle: '',
		selectedWorkspace: params?.workspacekey || '',
		eventCount: '14/14',
		deliverablesCount: '7/14',
		AlbumsCount: '3/5',
		finances: '₹ 6,60,000',
		hardrive: '0/0',
		clientExpenses: [],
		additionalServices: [],
		totalClientExpenses: 0,
		totalAdditionalServiceCost: 0,
		AdvancePayment: {},
		HardDrives: {},
		Pending: {},
		FirstEvent: {},
		lastEvent: {},
		userId: '',
		adminUserId: ['626d3751c5c41818a3994c97', '6128dd2f4253cefe5154c52b'],
		permissions: false,
		deliverableDatasource: [],
		eventsDatasorce: [],
		delivereableDate: '',
	});
	useEffect(() => {
		let json = {
			workspaceId: urlParams.workspaceID,
			projectId: urlParams.projectID,
		};
		getALlProjectDetails(json, urlParams.vendorID);
		json = {
			workspaceIds: urlParams.workspaceID,
		};
		getAllWorkspaceTenants(json, urlParams.vendorID);

		json = {
			filters: {
				projectId: urlParams.projectID,
				page: 1,
				limit: 100,
				wsTenantIds: pageInfo.selectedWorkspace,
			},
		};
		getAllVendorsEventDetails(json, urlParams.vendorID);
		getUserId();
		createDelay();
	}, []);

	const getUserId = useCallback(async () => {
		let usertoken = localStorage.getItem('usertoken');
		let decoded = await jwt_decode(usertoken);
		let permissions = pageInfo?.adminUserId.indexOf(decoded.user_id) >= 0 ? true : false;

		setPageInfo((prev) => {
			return {
				...prev,
				userId: decoded.user_id,
				permissions: permissions,
			};
		});
	}, []);

	useEffect(() => {
		if (projectVendorDetails) {
			const overallInsights = projectVendorDetails?.overallInsights;

			let eventCount = `${overallInsights?.shoots?.completed}/${overallInsights?.shoots?.total}`;
			let deliverables = `${overallInsights?.deliverables?.completed}/${overallInsights?.deliverables?.total}`;
			let finances = `${(
				overallInsights?.clientPayments?.total - overallInsights?.clientPayments?.completed
			)?.toLocaleString()} Due`;
			setPageInfo((prev) => {
				return {
					...prev,
					projectTitlle: projectVendorDetails.title,
					eventCount: eventCount,
					finances: finances,
					deliverablesCount: deliverables,
				};
			});

			let clientExpenses = {};
			const expenses = projectVendorDetails?.expenses;
			let totalClientExpenses = 0;
			if (expenses?.length) {
				for (let i = 0; i < expenses?.length; i++) {
					if (expenses[i].billTo === 'client') {
						totalClientExpenses += expenses[i]?.amount;
						if (clientExpenses[expenses[i]?.type]) {
							clientExpenses[expenses[i]?.type].value += expenses[i]?.amount;
						} else if (!expenses[i]?.type) {
							if (clientExpenses['others']) {
								clientExpenses['others'].value += expenses[i]?.amount;
							} else {
								clientExpenses['others'] = {
									properties: 'Others',
									value: expenses[i]?.amount,
								};
							}
						} else {
							clientExpenses[expenses[i]?.type] = {
								properties: expenses[i].type,
								value: expenses[i]?.amount,
							};
						}
					}
				}

				setPageInfo((prev) => {
					return {
						...prev,
						clientExpenses: Object.values(clientExpenses),
						totalClientExpenses,
					};
				});
			}

			let additionalService = [];
			let totalAdditionalServiceCost = 0;
			const additional = projectVendorDetails?.additionalServices;
			additionalService = additional?.map((e) => {
				totalAdditionalServiceCost += e.priceInRupees;
				return {
					properties: e.type,
					value: e.priceInRupees,
				};
			});

			setPageInfo((prev) => {
				return {
					...prev,
					additionalServices: additionalService,
					totalAdditionalServiceCost,
				};
			});
		}
	}, [projectVendorDetails]);

	useEffect(() => {
		if (projectVendorDetails) {
			const AdvancePaymentData = { state: 'Pending', date: '' };
			const payments = projectVendorDetails?.clientPayments
				?.filter((e) => e.isPaid === true)
				.sort((a, b) => (b?.dueDate || 0) - (a.dueDate || 0));
			for (let i = 0; i < payments?.length; i++) {
				if (payments[i].isPaid === true) {
					AdvancePaymentData.state = 'Completed';
					AdvancePaymentData.date = moment(`${payments[i]?.paidOn}`).format('D MMM YYYY');
				}
			}

			const hardDriveData = { state: 'Pending', date: '' };
			const hardDrive = projectVendorDetails?.hardDrives;
			for (let i = 0; i < hardDrive?.length; i++) {
				if (hardDrive[i].status === 'ready') {
					hardDriveData.state = 'Completed';
				}
			}

			const firstEventData = { state: '', date: '' };
			const firstEvent = projectVendorDetails?.firstEvent?.date; // Using optional chaining to safely access 'date'

			if (firstEvent) {
				// Now we can safely use 'firstEvent' since we've confirmed it's not null or undefined
				if (moment(firstEvent) < moment()) {
					firstEventData.state = 'Completed';
					firstEventData.date = moment(firstEvent).format('D MMM YYYY');
				} else {
					firstEventData.state = 'Pending';
					firstEventData.date = moment(firstEvent).format('D MMM YYYY');
				}
			}

			const lastEventData = { state: '', date: '' };
			const lastEvent = projectVendorDetails?.lastEvent?.date;

			if (lastEvent)
				if (moment(`${lastEvent}`) < moment()) {
					lastEventData.state = 'Completed';
					lastEventData.date = moment(`${lastEvent}`).format('D MMM YYYY');
				} else {
					lastEventData.state = 'Pending';
					lastEventData.date = moment(`${lastEvent}`).format('D MMM YYYY');
				}

			setPageInfo((prev) => {
				return {
					...prev,
					AdvancePayment: AdvancePaymentData,
					HardDrives: hardDriveData,
					FirstEvent: firstEventData,
					lastEvent: lastEventData,
				};
			});
		}
	}, [projectVendorDetails]);

	useEffect(() => {
		let eventsTableDatasource = [];

		if (projectEventDetails) {
			eventsTableDatasource = projectEventDetails?.data?.sort((a, b) => {
				if (!a?.date) {
					return 1;
				}
				if (!b?.date) {
					return -1;
				}
				return a.date - b.date;
			});

			setPageInfo((prev) => {
				return {
					...prev,
					eventsDatasorce: eventsTableDatasource,
				};
			});
		}
	}, [projectEventDetails]);

	useEffect(() => {
		let deliverableDatasource = [];
		let deliveredDate = [];
		if (projectVendorDetails) {
			deliverableDatasource = projectVendorDetails?.deliverables?.sort((a, b) => {
				if (!a?.dueDate) {
					return 1;
				}
				if (!b.dueDate) {
					return -1;
				}
				return a.dueDate - b.dueDate;
			});
			deliveredDate = deliverableDatasource.filter((e) => {
				return e.dueDate && moment(`${e.dueDate}`) >= moment();
			});
			deliveredDate = deliveredDate?.[0]?.dueDate || '';
			setPageInfo((prev) => {
				return {
					...prev,
					deliverableDatasource: deliverableDatasource,
					delivereableDate: deliveredDate,
				};
			});
		}
	}, [projectVendorDetails]);

	const createDelay = useCallback(() => {
		setTimeout(() => {
			setLoad(false);
		}, 200);
	}, []);

	const Eventscolumns = [
		{
			title: 'DATE / CITY',
			dataIndex: 'city',
			key: 'city',
			renderis: (record) => {
				return (
					<span
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							width: '85px',
						}}
					>
						<span>
							{record.date ? moment(`${record.date}`).format('D MMM YYYY') : ''}
						</span>
						<span
							className="stylingForBelowTxt"
							style={{ textTransform: 'capitalize' }}
						>
							{record.city}
						</span>
					</span>
				);
			},
		},
		{
			title: 'TYPE / VENUE',
			dataIndex: 'venue',
			key: 'venue',
			renderis: (record) => {
				return (
					<span
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
						}}
					>
						<span style={{ textTransform: 'capitalize' }}>{record.name}</span>
						<span
							className="stylingForBelowTxt"
							style={{ textTransform: 'capitalize' }}
						>
							{record.venue}
						</span>
					</span>
				);
			},
		},
		{
			title: 'CLIENT / MY EXPENSES',
			dataIndex: 'expenses',
			key: 'expenses',
			renderis: (record) => {
				let clientExpenses = 0;
				let myExpense = 0;
				const expenses = record?.expenses;
				for (let i = 0; i < expenses?.length; i++) {
					if (expenses[i].billTo === 'client') {
						clientExpenses += expenses[i].amount;
					} else {
						myExpense += expenses[i].amount;
					}
				}
				myExpense = '₹ ' + myExpense;
				clientExpenses = '₹ ' + clientExpenses;

				return (
					<span
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
						}}
					>
						<span>{clientExpenses}</span>
						<span className="stylingForBelowTxt">{myExpense}</span>
					</span>
				);
			},
		},
		{
			title: 'ADDITIONAL SERVICES',
			dataIndex: 'services',
			key: 'services',
			renderis: (record) => {
				let cam = <FadeCamera />;
				let drone = <FadeDrone />;
				let filter = <FadeFilters />;
				let vide = <FadeVideo />;
				if (record.additionalServices?.length) {
					const addServices = record.additionalServices;
					for (let i = 0; i < addServices.length; i++) {
						if (addServices[i].type === 'drone') {
							drone = <ActiveDrone />;
						} else if (addServices[i].type === 'mixingUnit') {
							filter = <ActiveFilters />;
						} else if (addServices[i].type === 'webLive') {
							vide = <ActiveVideo />;
						} else if (addServices[i].type === 'led') {
							cam = <ActiveCamera />;
						}
					}
				}
				return (
					<span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
						{drone}
						{vide}
						{cam}
						{filter}
					</span>
				);
			},
		},
		{
			title: 'DATA',
			dataIndex: 'data',
			key: 'data',
			renderis: (record) => {
				if (record.flagLabel) {
					if (record.flagLabel === 'red') {
						return (
							<span style={{ display: 'flex', gap: '4px' }}>
								<FadeGreenFlag />
								<FadeYellowFlag />
								<ActiveRedFlag />
							</span>
						);
					} else if (record.flagLabel === 'yellow') {
						return (
							<span style={{ display: 'flex', gap: '4px' }}>
								<FadeRedFlag />
								<FadeGreenFlag />
								<ActiveYellowFlag />
							</span>
						);
					} else {
						return (
							<span style={{ display: 'flex', gap: '4px' }}>
								<FadeRedFlag />
								<FadeYellowFlag />
								<ActiveGreenFlag />
							</span>
						);
					}
				}
				return (
					<span style={{ display: 'flex', gap: '4px' }}>
						<FadeRedFlag />
						<FadeGreenFlag />
						<FadeYellowFlag />
					</span>
				);
			},
		},
	];

	const hardDricesColumnns = [
		{
			title: 'SERIAL / QR',
			dataIndex: 'serial',
			key: 'serial',
			renderis: (record) => {
				return <span>{record.qrCode}</span>;
			},
		},
		{
			title: 'LOCATIONS',
			dataIndex: 'locations',
			key: 'loctions',
			renderis: (record) => {
				return <span></span>;
			},
		},
		{
			title: 'STATUS',
			dataIndex: 'status',
			key: 'status',
			renderis: (record) => {
				let status = record.status;
				const styeleobj = {};
				if (status == 'busy') {
					styeleobj.color = '#CB3636';
				} else if (status == 'delivered') styeleobj.color = '#38841E';
				else if (status === 'ready') {
					styeleobj.color = '#217CE5';
				}
				status = status.charAt(0).toUpperCase() + status.slice(1);
				return <span style={styeleobj}>{status}</span>;
			},
		},
		{
			title: 'PAID BY',
			dataIndex: 'paid',
			key: 'paid',
			renderis: (record) => {
				return <span>Client</span>;
			},
		},
	];

	const AlbumsColumns = [
		{
			title: 'TITLE',
			dataIndex: 'title',
			key: 'title',
		},
		{
			title: 'LOCATIONS',
			dataIndex: 'location',
			key: 'location',
		},
		{
			title: 'STATUS',
			dataIndex: 'status',
			key: 'status',
		},
	];

	const albumDatasource = [
		{
			title: 'Reception Album',
			location: 'Mumbai',
			status: 'Not Delivered',
		},
	];

	const delivarbleColumn = [
		{
			title: 'TASK',
			dataIndex: 'task',
			key: 'task',
			renderis: (record) => {
				let icon = <DoubleArrowIcon />;
				const priority = record.priority;
				if (priority === 'medium') {
					icon = <EqualIcon />;
				} else if (priority === 'low') {
					icon = <DownIcon />;
				} else if (priority === 'high') {
					icon = <ArrowIcon />;
				}

				return (
					<span
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '5px',
							textTransform: 'capitalize',
						}}
					>
						{icon} {record.title}
					</span>
				);
			},
		},
		{
			title: 'STATUS',
			dataIndex: 'status',
			key: 'status',
			renderis: (record) => {
				let status = record.status;
				const styeleobj = {};
				if (status == 'todo') {
					if (!record.dueDate) {
						status = 'Unscheduled';
						styeleobj.color = 'rgba(249, 127, 38, 0.90)';
					} else if (moment(`${record.dueDate}`) > moment()) {
						status = 'To Do';
						styeleobj.color = '#9F4DB7';
					} else {
						status = 'Overdue';
						styeleobj.color = 'rgba(170, 20, 20, 0.90)';
					}
				} else if (status == 'inProgress') {
					styeleobj.color = '#5383EC';
					status = 'In Progress';
				} else if (status === 'inReview') {
					styeleobj.color = '#8EE2C7';
					status = 'In Review';
				} else {
					styeleobj.color = '#38841E';
					status = 'Completed';
				}
				status = status.charAt(0).toUpperCase() + status.slice(1);
				return <span style={styeleobj}>{status}</span>;
			},
		},
		{
			title: 'ASSIGNED DATE / TO',
			dataIndex: 'assigned',
			key: 'assigned',
			renderis: (record) => {
				// const tennantId = workspaceTenants?.tenantUsersList?.filter(
				// 	(ele) => ele.id === record.assignedTo,
				// );
				// const name = tennantId?.length
				// 	? tennantId?.[0]?.firstName + ' ' + tennantId?.[0]?.lastName
				// 	: '';
				return (
					<span style={{ textTransform: 'capitalize' }}>
						{_.has(record.assignedTo, 'name') ? record.assignedTo.name : ''}
					</span>
				);
			},
		},
		{
			title: 'DUE DATE',
			dataIndex: 'duedate',
			key: 'dueDate',
			renderis: (record) => {
				return (
					<span>
						{record?.dueDate ? moment(`${record.dueDate}`).format('D MMM YYYY') : ''}
					</span>
				);
			},
		},
	];

	const ChecklistDemoData = [
		{
			state: pageInfo.AdvancePayment?.state,
			title: 'Advance Payment',
			timings: pageInfo.AdvancePayment?.date
				? `Last Payment Updated on ${pageInfo.AdvancePayment?.date}`
				: '',
		},
		{
			state: pageInfo.HardDrives?.state,
			title: 'Hard Drives Registered',
			// timings: 'Last Payment Updated on 23 July 2023',
		},

		{
			state: pageInfo.FirstEvent?.state,
			title: 'First Event',
			timings: `First Event Finished on ${pageInfo.FirstEvent?.date}`,
		},
		{
			state: pageInfo.lastEvent?.state,
			title: 'Last Event',
			timings: `Last Event Completed on ${pageInfo.lastEvent?.date}`,
		},
		{
			state: 'Pending',
			title: 'All Expenses Approved',
			timings: 'Last Payment Updated on 23 July 2023',
		},
		{
			state: 'unknown',
			title: 'Full Payment',
			timings: 'Last Payment Updated on 23 July 2023',
		},
	];

	useEffect(() => {
		const totalCount = projectVendorDetails?.hardDrives?.length;
		let deliveredCount = 0;
		const hardDrivesdata = projectVendorDetails?.hardDrives;
		if (totalCount) {
			for (let i = 0; i < totalCount; i++) {
				if (hardDrivesdata[i].status === 'delivered') {
					deliveredCount++;
				}
			}

			setPageInfo((prev) => {
				return {
					...prev,
					hardrive: `${deliveredCount}/${totalCount}`,
				};
			});
		}
	}, [projectVendorDetails?.hardDrives]);

	const Navigate = (type) => {
		if (type === 'deliverables')
			navigate(
				`/${urlParams.vendorID}/deliverables/${urlParams.workspaceID}/${urlParams.projectID}?workspaceId=${params?.workspacekey}&projectLabel=${pageInfo.projectTitlle}`,
			);

		if (type === 'events')
			navigate(
				`/${urlParams.vendorID}/shoots/${urlParams.workspaceID}/${urlParams.projectID}`,
			);

		if (type === 'drives')
			navigate(
				`/${urlParams.vendorID}/harddrives?page=1&limit=20&workspace=${urlParams.workspaceID}`,
			);
	};

	return (
		<div className="assign-receive-container">
			{(!projectEventDetails && !projectEventDetails && params?.workspacekey) || load ? (
				<LoadingBar />
			) : (
				<div
					style={{
						color: 'white',
						marginLeft: '0.8vw',
						padding: '2%',
						paddingRight: '0',
						backgroundColor: '#090909',
						width: 'auto',
					}}
				>
					<ProjectOverviewHeader
						workspacekey={urlParams.workspaceID}
						title={pageInfo.projectTitlle}
						firstEvent={projectVendorDetails?.firstEvent?.date}
						lastEvent={projectVendorDetails?.lastEvent?.date}
					/>

					<div className="InfocardsContainer">
						<ProjectInfoCards
							cardsbgColor="#707070"
							designColor="#B0B0B0"
							iconType="events"
							data={{
								title: 'Events',
								count: pageInfo.eventCount,
								details: `Last event on ${moment(
									`${projectVendorDetails?.lastEvent?.date}`,
								).format('D MMM YYYY')}`,
							}}
						/>

						{/* <ProjectInfoCards
							cardsbgColor="linear-gradient(136deg, #1BA159 0%, #084424 100%)"
							designColor="rgba(34, 188, 105, 0.30)"
							iconType="finances"
							data={{
								title: 'Finances',
								count: `₹ ${pageInfo.finances}`,
								// details: 'Finance Scheduled 20th July ‘23',
							}}
						/> */}
						<ProjectInfoCards
							cardsbgColor="linear-gradient(136deg, #A63ECD 0%, #9E1C88 100%)"
							designColor="rgba(191, 127, 195, 0.40)"
							iconType="drives"
							data={{
								title: 'Hard Drives',
								count: pageInfo.hardrive,
								details: '',
							}}
						/>
						<ProjectInfoCards
							cardsbgColor="linear-gradient(136deg, #274FB7 0%, #0C2B79 100%)"
							designColor="rgba(49, 92, 203, 0.40)"
							iconType="deliverable"
							data={{
								title: 'Deliverables',
								count: pageInfo.deliverablesCount,
								details: pageInfo?.delivereableDate
									? `Send wedding teaser on ${moment(
											`${pageInfo?.delivereableDate}`,
									  ).format('D MMM YYYY')}`
									: '',
							}}
						/>
						<ProjectInfoCards
							cardsbgColor="linear-gradient(136deg, #FF865B 0%, #932905 100%)"
							designColor="rgba(255, 150, 113, 0.70)"
							opacity="0.4000000059604645"
							iconType="albums"
							data={{
								title: 'Albums',
								count: pageInfo.AlbumsCount,
								details: 'Send album for print on 23rd July ‘23',
							}}
						/>
					</div>

					<div className="gridContainer">
						<div className="grid1">
							<Cards
								title="Project Checklist"
								count="(2/7)"
								type="TimelineComponent"
								data={ChecklistDemoData}
							/>
							<EventsTable
								columns={hardDricesColumnns}
								datasource={projectVendorDetails?.hardDrives || []}
								name="Hard Drives"
								count={`(${pageInfo.hardrive})`}
								width="100%"
								onGoTo={() => Navigate('drives')}
							/>
							<EventsTable
								columns={AlbumsColumns}
								datasource={albumDatasource}
								name="PRINT ALBUMS"
								count="(3/5)"
								width="100%"
								onGoTo={() => Navigate('albums')}
							/>
						</div>

						<div className="grid2">
							<EventsTable
								columns={Eventscolumns}
								datasource={pageInfo?.eventsDatasorce || []}
								name="Events"
								count={`(${pageInfo.eventCount})`}
								width="100%"
								onGoTo={() => Navigate('events')}
							/>
							<EventsTable
								columns={delivarbleColumn}
								datasource={pageInfo?.deliverableDatasource || []}
								name="Deliverables"
								count={`(${pageInfo.deliverablesCount})`}
								width="100%"
								onGoTo={() => Navigate('deliverables')}
							/>
						</div>
						{/* <div className="grid3">
							<CollapsebaleComponent
								paymentdata={
									projectVendorDetails?.overallInsights?.clientPayments || ''
								}
								collapsedata={projectVendorDetails?.clientPayments}
								quotationPrice={projectVendorDetails?.quotationPrice}
								addServicesCost={pageInfo?.totalAdditionalServiceCost}
								clientExpensesCost={pageInfo?.totalClientExpenses}
								permissions={pageInfo.permissions}
							/>
							{pageInfo?.additionalServices?.length && pageInfo?.permissions ? (
								<Cards
									title="Additional Service"
									count=""
									data={pageInfo?.additionalServices}
								/>
							) : (
								''
							)}

							{pageInfo?.clientExpenses?.length && pageInfo?.permissions ? (
								<Cards
									title="Client Expenses"
									count=""
									data={pageInfo?.clientExpenses}
								/>
							) : (
								''
							)}
						</div> */}
					</div>
				</div>
			)}
		</div>
	);
};

export default ProjectsOverviewPage;
